export enum GAEvent {
  GenericError = 'errorGAEvent',
  GenericEvent = 'genericGAEvent',
  PageView = 'spa-pageview',
}
